import {ADD_HABIT, REMOVE_HABIT, SET_RECURRENCE} from "./constants";
import Axios from "axios";

export function addHabit(habit){
   return {
      type: ADD_HABIT, 
      habit
   }
}

export function removeHabit(id){
   return {
      type: REMOVE_HABIT, 
      id
   }
}


export function setRecurrence(id, recurrence){
   return {
      type: SET_RECURRENCE, 
      id, 
      recurrence
   }
}


